import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';
import ErrorPage from './ErrorPage';
import schema from './props-schema';

ErrorPage.schema = schema;
ErrorPage.defaultProps = getEmptyDefaultProps(schema.templateSettings);

// https://github.com/webpack/webpack/issues/706
export default ErrorPage;
